import { Component } from '@angular/core';
import { Globals } from '../../services/globals';
import { TestChartService } from '../../services/test-chart.service';

@Component({
  selector: 'test-chart',
  templateUrl: './test-chart.html',
  inputs: ['bleft', 'bright'],
  styleUrls: ['./test-chart.scss'],
})

export class TestChartPage {

  /**
   * 아동 리스트
   */
  private childList: any[];

  /**
   * 아동 식별번호
   */
  private bmiNum: number;

  /**
   * 뇌 정보
   */
  brainInfoObj: any = {
    symptom : '',
    leftValue : 0,
    rightValue : 0,
    date: '',
    explanation : '',
  };

  /**
   * 뇌 평가 ? 결과
   */
  brainResultObj: any = {
    result : '',
    left : '',
    right : '',
  };

  /**
   * 뇌 그래프
   */
  brainGraphObj: any = this.initData();

  chartShow: boolean = false;

  constructor(
    private $testChartService: TestChartService,
    private $g: Globals) {
    this.childList = this.$g.children;
    this.viewEnter();
  }

  viewEnter() {
    this.brainInfoObj.leftValue = 0;
    this.brainInfoObj.rightValue = 0;
    this.bmiNum = this.$g.child.num;
    this.childList.forEach((child) => {
      if (child.num === this.bmiNum) {
        this.brainInfoObj.symptom = child.symptom;
      }
    });

    this.getBrainExplanation();
    this.getTestExplanation();
  }

  /**
   * 데이터 초기화
   */
  initData(): any {
    return {
      eye : {
        title : null,
        titleInfo : null,
        info : null,
        graphVaule : null,
      },
      sense : {
        title : null,
        titleInfo : null,
        info : null,
        graphVaule : null,
      },
      muscle : {
        title : null,
        titleInfo : null,
        info : null,
        graphVaule : null,
      },
      cross : {
        title : null,
        titleInfo : null,
        info : null,
        graphVaule : null,
      },
      space : {
        title : null,
        titleInfo : null,
        info : null,
        graphVaule : null,
      },
      exe_cel : {
        title : null,
        titleInfo : null,
        info : null,
        graphVaule : null,
      },
      plan : {
        title : null,
        titleInfo : null,
        info : null,
        graphVaule : null,
      },
    };
  }

  /**
   * 뇌 설명 정보 획득
   */
  getBrainExplanation () {
    this.$testChartService.getBrainBalanceExplanation(this.bmiNum).subscribe(
      (res) => {
        if (!res) return;
        const left = Math.round(res.left);
        const right = Math.round(res.right);
        this.brainInfoObj.leftValue = left || 0;
        this.brainInfoObj.rightValue = right || 0;
        this.brainInfoObj.date = res.date;
        this.brainInfoObj.explanation = res.brainResult.explanation;
        this.brainResultObj.left = res.brainResult.left;
        this.brainResultObj.right = res.brainResult.right;
        this.brainResultObj.result = res.brainResult.result;
      },
      (err) => {
        console.log('err', err);
      });
  }

  /**
   * 검사 설명 정보 획득
   */
  getTestExplanation () {
    this.$testChartService.getTestExplanation(this.bmiNum).subscribe(
      (data) => {
        this.brainGraphObj.eye = {
          title : data.eye.title,
          titleInfo : data.eye.titleInfo,
          info : data.eye.info,
          graphVaule : data.eye.value,
        };

        this.brainGraphObj.sense = {
          title : data.sense.title,
          titleInfo : data.sense.titleInfo,
          info : data.sense.info,
          graphVaule : data.sense.value,
        };

        this.brainGraphObj.muscle = {
          title : data.muscle.title,
          titleInfo : data.muscle.titleInfo,
          info : data.muscle.info,
          graphVaule : data.muscle.value,
        };

        this.brainGraphObj.cross = {
          title : data.cross.title,
          titleInfo : data.cross.titleInfo,
          info : data.cross.info,
          graphVaule : data.cross.value,
        };

        this.brainGraphObj.space = {
          title : data.space.title,
          titleInfo : data.space.titleInfo,
          info : data.space.info,
          graphVaule : data.space.value,
        };

        this.brainGraphObj.exe_cel = {
          title : data.exe_cel.title,
          titleInfo : data.exe_cel.titleInfo,
          info : data.exe_cel.info,
          graphVaule : data.exe_cel.value,
        };

        this.brainGraphObj.plan = {
          title : data.plan.title,
          titleInfo : data.plan.titleInfo,
          info : data.plan.info,
          graphVaule : data.plan.value,
        };
      },
      (err) => {
        console.log('err', err);
      });
  }
}
